import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiClientService } from '../../shared/api-client.service';

@Injectable()
export class UserService {
  private intercomBooted = false;

  constructor(private apiClientService: ApiClientService) {}

  loadUser() {
    return this.apiClientService.get('/whoami').map(user => {
      if (typeof (<any>window).Intercom !== 'undefined') {
        let action = 'update';
        const payload = {
          created_at: user.createdAt,
          companies: [{ company_id: user.accountId, name: user.organization }]
        };
        if (this.intercomBooted === false) {
          action = 'boot';
          payload['email'] = user.email;
          payload['app_id'] = environment.intercomAppId;
          this.intercomBooted = true;
        }

        (<any>window).Intercom(action, payload);
      }
      return user;
    });
  }
}
